<template lang="pug">
  div.sc-card(:class="{'sc-card--big': size === 'big', 'sc-card--small': size === 'small', 'sc-card--without-shadow': shadow}")
    div.sc-card__header
      div.sc-card__header__inner
        slot(name="header")
    div.sc-card__body(v-loading="loading")
      ods-scrollbar(v-if="scrollbar" wrap-class="ods-scrollbar__wrap")
        div.sc-card__body-inner
          slot
      div.sc-card__body-inner(v-else)
        slot
</template>

<script>

export default {
  name: 'Card',
  data () {
    return {
    }
  },
  props: {
    size: {
      type: String
    },
    shadow: {
      type: Boolean,
      default: true
    },
    scrollbar: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.card-title{
  font-family: 'Soho'
}
.sc-card{
  background-color: $--color-white;
  border-radius: 4px;
  box-shadow: 0 2px 10px 0 rgba(0,0,0,0.05);
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
  &__header{
    padding: 14px 32px 0 32px;
    box-sizing: border-box;
    &__inner{
      box-sizing: border-box;
      min-height: 46px;
      padding-bottom: 14px;
      //border-bottom: 1px solid $--color-grey-light;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  &__body{
    padding: rem(24) rem(24) 0;
  }

  &--small{
    .sc-card__body{
      // min-height: rem(384);
      min-height: rem(384);
    }

    /deep/ .ods-scrollbar__wrap{
      max-height: 30rem;
    }

    .sc-card__body{
      padding: rem(8) rem(24) 0;
    }
  }

  &--big{
    .sc-card__body{
      min-height: rem(498);
    }

    /deep/ .ods-scrollbar__wrap{
      max-height: rem(474);
    }

    // .sc-card__body{
    //   padding: rem(24);
    // }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Card.vue